export function getUserFromSession() {
  try {
    return JSON.parse(sessionStorage.getItem('user') || 'null');
  } catch {
    return null;
  }
}

export function getUserEmailFromSession() {
  const user = getUserFromSession();
  return user?.email || '';
}

/** 兼容后端 is_admin 为 1 / true / "1" / "true" 等写法 */
export function isAdminUser(user) {
  if (!user) return false;
  const v = user.is_admin;
  if (v === 1 || v === true) return true;
  if (typeof v === 'string') {
    const s = v.trim().toLowerCase();
    return s === '1' || s === 'true';
  }
  return false;
}

export function syncIsAdminSession(user) {
  sessionStorage.setItem('isAdmin', isAdminUser(user) ? 'true' : 'false');
}

/** 优先 sessionStorage，否则从 user 对象推断（修复登录时 is_admin 类型不一致） */
export function getIsAdminFromSession() {
  if (sessionStorage.getItem('isAdmin') === 'true') return true;
  return isAdminUser(getUserFromSession());
}
 